let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3nUFq")).then(() => parcelRequire('9ikOx'));